<template>
  <div class="checkout-member-blocks">
    <MemberBlock
      v-for="(block, index) in blocks"
      :key="index"
      :block="block"
      :index="index"
      :remaining-years="remainingYears"
    />

    <div
      v-if="canAddMemberBlock || canRemoveMemberBlock"
      class="checkout-member-blocks__actions"
    >
      <button
        v-if="canAddMemberBlock"
        type="button"
        class="btn btn--fill btn--small"
        @click="addMemberBlock"
      >
        Add Member
      </button>

      <button
        v-if="canRemoveMemberBlock"
        type="button"
        class="btn btn--small"
        @click="removeMemberBlock"
      >
        Remove Member
      </button>
    </div>
  </div>
</template>

<script>
import MemberBlock from './components/MemberBlock'

export default {
  name: 'MembershipSetup',

  components: {
    MemberBlock
  },

  data() {
    return {
      availableYears: window._availableMembershipYears,
      usedYears: 0,
      blocks: []
    }
  },

  computed: {
    remainingYears() {
      return this.availableYears - this.usedYears
    },

    canAddMemberBlock() {
      return this.remainingYears > 0
    },

    canRemoveMemberBlock() {
      return this.blocks.length > 1
    }
  },

  created() {
    this.addMemberBlock()

    this.$root.$on('increase-years', () => {
      this.usedYears = this.usedYears + 1
    })

    this.$root.$on('decrease-years', () => {
      this.usedYears = this.usedYears - 1
    })
  },

  methods: {
    addMemberBlock() {
      this.blocks.push({
        usedYears: this.remainingYears
      })

      this.usedYears = this.availableYears
    },

    removeMemberBlock() {
      const lastIndex = this.blocks.length - 1
      const block = this.blocks[lastIndex]

      this.usedYears = this.usedYears - block.usedYears

      this.$delete(this.blocks, lastIndex)
    }
  }
}
</script>
